<template>
  <div class="search-bar-with-icon">
    <input
      type="text"
      v-model="internalSearchValue"
      :placeholder="placeholder"
      class="search-input common-search-bar"
      @change="$emit('change', $event)"
      @keyup="$emit('keyup', $event)"
      @input="onInput"
      v-on:keyup.enter="handleEnter"
      @blur="$emit('blur')"
    />
    <div class="search-icon-click-area" @click="handleIconClick"></div>
    <button
      v-if="internalSearchValue"
      @click="clearText"
      class="search-icon-click-clear icon-delete"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    placeholder: {
      type: String,
      default: 'Search' // Valor predeterminado para el placeholder
    },
    value: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      internalSearchValue: this.value
    }
  },
  watch: {
    modelValue(newValue) {
      this.internalSearchValue = newValue
    },
    internalSearchValue(newValue) {
      this.$emit('update:modelValue', newValue)
    }
  },
  methods: {
    handleEnter() {
      this.$emit('search', this.internalSearchValue)
    },
    handleIconClick() {
      this.$emit('search', this.internalSearchValue)
    },
    onInput() {
      this.$emit('input', this.internalSearchValue ?? '')
    },
    clearText() {
      this.internalSearchValue = ''
      this.$emit('input', '')
    }
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value ?? ''
      },
      set: function () {}
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/core/styles/variables.styl"
@import "~@/core/styles/mixins.styl"

.search-bar-with-icon
  position relative
  display inline-block
  width 100%

  .search
    &-input
      width: 100%
      padding-right 10px
      padding-left: 45px

    &-icon-click-area
      position: absolute
      top 0
      left 0
      width 30px
      height 100%
      cursor pointer

      &::before
        content ''
        position absolute
        width 30px
        height 30px
        left 6px
        top 5px
        pointer-events none
        background-repeat no-repeat
        background-position center
        background-size contain
        -o-background-size contain
        background-image url(/img/search-input-icon.d499235b.svg)
        z-index 1

    &-icon-click-clear
      position: absolute
      top: 50%
      right: 9px
      transform: translateY(-50%);
      cursor: pointer
      border: none
      background: none
      font-weight: bold
      font-size: 12px
      color: #4b59ac
      transition: opacity 0.2s ease-in-out
</style>
